// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkinTwoToneSvg from "@fishx/icons-svg/es/asn/SkinTwoTone";
import FishxIcon from '../components/FishxIcon';

var SkinTwoTone = function SkinTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkinTwoToneSvg
  }));
};

SkinTwoTone.displayName = 'SkinTwoTone';
export default React.forwardRef(SkinTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SkinTwoTone.js
// module id = 4129
// module chunks = 0